import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONSTANTS, FILE_TYPE_ID } from '../constants/constants';
import { iif, map, Observable, tap } from 'rxjs';
import {
  Organization,
  OrganizationListResponse,
  OrganizationResponse,
} from '../types/organization.type';

@Injectable({
  providedIn: 'root',
})
export class OrganizationsService {
  private organizations: OrganizationListResponse;

  constructor(private http: HttpClient) {}

  getOrganization(id: number): Observable<Organization> {
    return this.http.get<Organization>(
      `${CONSTANTS.BASE_API}organizations/${id}`
    );
  }

  getOrganizationsSortedByEventCount(): Observable<Organization[]> {
    return this.getOrganizations().pipe(
      map((response) =>
        response.data
          .filter((item) => item.event_count > 0)
          .sort((a, b) => b.event_count - a.event_count)
          .slice(0, 12)
      )
    );
  }

  getOrganizations(): Observable<OrganizationListResponse> {
    if (this.organizations) {
      return new Observable((subscriber) => {
        subscriber.next(this.organizations);
      });
    }

    return this.http
      .get<OrganizationListResponse>(`${CONSTANTS.BASE_API}organizations`)
      .pipe(
        tap((res) => {
          this.organizations = res;
        })
      );
  }

  saveUpdateOrganization(organization: any): Observable<OrganizationResponse> {
    return iif(
      () => organization.organization_id,
      this.updateOrganization(organization, organization.organization_id),
      this.saveOrganization(organization)
    );
  }

  saveOrganization(body: any): Observable<OrganizationResponse> {
    return this.http.post<OrganizationResponse>(
      `${CONSTANTS.BASE_API}organizations`,
      body
    );
  }

  updateOrganization(body: any, id: number): Observable<OrganizationResponse> {
    return this.http.patch<OrganizationResponse>(
      `${CONSTANTS.BASE_API}organizations/${id}`,
      body
    );
  }

  deleteOrganization(id: number): Observable<Organization> {
    return this.http.delete<Organization>(
      `${CONSTANTS.BASE_API}organizations/${id}`
    );
  }

  followOrganization(id: number): Observable<Organization> {
    return this.http.get<Organization>(
      `${CONSTANTS.BASE_API}organizations/${id}/follow`
    );
  }

  updateLogo(file: File, organizationId: number): Observable<Object> {
    const formData = new FormData();

    formData.append('file_type_id', String(FILE_TYPE_ID.LOGO));
    formData.append('file', file);

    return this.http.post(
      `${CONSTANTS.BASE_API}organizations/${organizationId}/files/upload`,
      formData
    );
  }
}
